import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'gyakutai-boushi-mijisshi-gensan',
    title: '虐待防止措置未実施減算｜委員会・研修・担当者の3つで1%減',
    description:
        '虐待防止措置未実施減算の要件は、虐待防止委員会の年1回以上の開催・虐待の防止のための研修の年1回以上の実施・虐待防止担当者の配置の3つ。1つでも欠けると利用者全員の基本報酬が1%減ります。指針の作成が減算要件ではない理由と、法人単位や身体拘束適正化検討委員会との一体開催で回す方法を、議事録の文例つきで解説します。',
    excerpt:
        '虐待防止委員会も研修もやっている。それでも担当者の配置が抜けていれば1%減です。3つの要件をチェックリストにして、議事録の文例まで載せました。',
    category: '運営指導',
    keywords: [
        '虐待防止措置未実施減算',
        '虐待防止委員会 頻度',
        '虐待防止 研修 減算',
        '虐待防止担当者 配置',
        '虐待防止委員会 議事録'
    ],
    publishedAt: '2026-08-26',
    updatedAt: '2026-08-26',
};
